import React from 'react'
import banner from "../../../images/students/collegr.webp"

export default function Colleges() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] md:p-[40px] relative z-0 w-11/12 overflow-hidden text-center bg-[#FFFFFF] mx-auto rounded-[14px] md:rounded-[40px]' style={{ boxShadow: "0px 0px 15px -3px #0000001A" }}>
            <img src={banner} alt='banner' loading='lazy' className='mx-auto object-cover w-[120px] md:w-[190px]' />
            <div className='mt-[14px] md:mt-[25px]'>
                <h3 className='text-[#101828] text-[24px] md:text-[54px] font-semibold'>Bulk access for colleges</h3>
                <p className='mt-[5px] md:mt-[10px] text-[#7D7F81] font-normal text-[14px] md:text-[25px]'>Colleges can purchase bulk packages for their entire campus, starting at ₹499/student. Instantly upgrade clarity and real-world readiness.</p>
            </div>
            <button className='w-full md:w-[346px] h-[40px] md:h-[64px] mt-[34px] rounded-[12px] bg-[#34C759] text-[#FFFFFF] text-[16px] md:text-[24px] font-semibold'
                onClick={() => {
                    const slotDiv = document.getElementById("slot");
                    if (slotDiv) {
                        slotDiv.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                }}>
                Book a Demo
            </button>
        </div>
    )
}
